import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router"
import { useAuth } from "hooks/use-auth"
import { useUserType } from "hooks/use-user-type"
import { useEffect } from "react"
import { FeedbackPill } from "@/components/feedback-pill"
import { PageLoader } from "@/components/page-loader"
import { SidebarProvider } from "@/components/ui/sidebar"

export const Route = createFileRoute("/_authed")({
  component: AuthedLayout,
})

function AuthedLayout() {
  const { isAuthenticated, isLoading } = useAuth()
  const { isProfessional } = useUserType()
  const navigate = useNavigate()
  const pathname = useLocation({ select: (location) => location.pathname })

  useEffect(() => {
    // Don't do anything while loading
    if (isLoading) {
      return
    }

    // Redirect to sign in if not authenticated
    if (!isAuthenticated) {
      navigate({
        to: "/sign-in",
        search: {
          redirect: window.location.pathname + window.location.search,
        },
      })
      return
    }

    // Redirect professionals to their dashboard only if pathname contains 'personal'
    if (isProfessional && pathname.includes("personal")) {
      navigate({
        to: "/professional/clients",
        replace: true,
      })
      return
    }
  }, [isAuthenticated, isLoading, isProfessional, navigate, pathname])

  if (isLoading) {
    return <PageLoader />
  }

  if (!isAuthenticated) {
    return null // Will redirect in useEffect
  }

  return (
    <SidebarProvider>
      <Outlet />
      <FeedbackPill />
    </SidebarProvider>
  )
}
